var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dx-load-panel',{attrs:{"shadingColor":"rgba(0,0,0,0.4)","visible":_vm.loadingVisible,"showIndicator":true,"showPane":true,"shading":true,"closeOnOutsideClick":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }